import { forwardRef } from 'react'
import { SVGs } from '../..'
import SVG from '../SVG'
import { SelectButtonProps } from './props'
import { StyledIcon, StyledSelectButton } from './styles'

const SelectButton = forwardRef<HTMLButtonElement, SelectButtonProps>(
    ({ text, ...props }, ref) => (
        <StyledSelectButton {...props} ref={ref} size="large" variant="option">
            {text}
            <StyledIcon active={props.active}>
                <SVG src={SVGs.CheckCircleFilled} />
            </StyledIcon>
        </StyledSelectButton>
    )
)

SelectButton.displayName = 'SelectButton'

export default SelectButton
export { StyledSelectButton }
